import React from "react";

import Button from "../../Components/Button";
import Icon from "../../Components/Icon";
import CommonModal from "../../Components/Modal";
import "./style.scss";

interface DeleteModalProps {
  isOpen: boolean;
  toggle: () => void;
  title: string;
  entityName: string;
  entityDetails?: string;
  warningItems?: string[];
  onConfirm: () => void;
  loading?: boolean;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  toggle,
  title,
  entityName,
  entityDetails,
  warningItems,
  onConfirm,
  loading,
}) => {
  return (
    <CommonModal isOpen={isOpen} toggle={toggle} title={title} size="md">
      <div className="delete-modal">
        <div className="modal-content-custom">
          <p className="confirmation-text">
            Are you sure you want to delete <strong>{entityName}</strong>
            {entityDetails && ` (${entityDetails})`}?
          </p>

          <div className="warning-box">
            <div className="warning-header">
              <Icon name="risks" />
              <span className="warning-title">
                Warning: This action cannot be undone
              </span>
            </div>
            {warningItems && warningItems.length > 0 && (
              <>
                <p className="warning-subtitle">
                  This will permanently delete:
                </p>
                <ul className="warning-list">
                  {warningItems.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </div>

        <div className="modal-actions">
          <Button variant="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button loading={loading} variant="danger" onClick={onConfirm}>
            Delete
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default DeleteModal;
